<template>
<div class="addfile-wrap" :class="modelValue ? '' : 'hide'">
    <div class="content">
        <div class="head">{{$t('design.orderDetail.supplementaryFileList') || '补充文件列表'}}<i class="close" @click="onClose"></i></div>
        <xl-scrollbar>
        <div class="list">
            <div class="types-wrap">
                <span v-for="(item, index) in typeList" :key="index"
                    class="type-item"
                    :class="activeType === item.detailType ? 'type-item-active' : ''"
                    @click="onClickType(item)">
                    {{ item.imageName }}
                </span>
            </div>
            <xl-form :model="form" label-position="top" v-show="activeType">
                <xl-form-item 
                    :label="$t('design.case.supply.file') || '文件上传'"
                    :key="index"
                    >
                    <xl-upload2 
                        category="dentalx" 
                        :isPrivate="false"
                        drag 
                        listType="picture" 
                        isBigFile 
                        :auto-upload="true"
                        v-model:file-list="form.fileList"
                        @remove="onRemove" 
                        :before-upload="beforeUpload"
                        @success="uploadedsuccess(item)" 
                        :text="$t('design.case.addOrDragFile') || '添加或拖入文件'"
                        :maxSize="formConfig.maxSize"
                        :accept="formConfig.accept"
                        :tip="formConfig.tip"
                        :outOfSizeTip="formConfig.outOfSizeTip"
                        :typeErrorTip="formConfig.tip"
                        @error="uploadErrorHandler"
                        :typeErrorList="formConfig.typeErrorList"
                        >
                        <template #file="{file}">
                            <div class="file-detailName">{{ file?.raw.imageName}}</div>
                            <div class="xl-upload-file">
                                <div class="xl-upload-file-l">
                                <div class="xl-upload-file-lbg">
                                    <span>{{ getFileExt(file?.name) }}</span>
                                </div>
                                <div class="xl-upload-file-c">
                                    <div
                                    class="xl-upload-file-ct"
                                    :style="fileMaxWidth ? 'max-width:' + fileMaxWidth + 'px' : ''"
                                    >
                                    <div class="file-name">{{ getFileNameWithoutExt(file?.name) }}</div>
                                    <div class="file-ext">{{ getFileExt(file?.name) }}</div>
                                    </div>
                                    <div v-if="file?.status === 'uploading'" class="xl-upload-file-c-progress">
                                    <div class="xl-upload-file-c-progress-inner" :style="'width:' + file?.percentage + '%'"></div>
                                    </div>
                                    <div v-if="file?.status !== 'uploading' && file?.size" class="xl-upload-file-cb">
                                    {{ formatFileSize(file?.size) }}
                                    </div>
                                </div>
                                </div>
                                <div class="xl-upload-file-r" :class="file?.status ==='success' ? 'is-success' : ''">
                                <div v-if="file?.status ==='success'" class="file-status"></div>
                                <div
                                    class="file-clean"
                                    @click.stop="upRemove(file, file?.raw)"
                                ></div>
                                </div>
                            </div>
                        </template>
                    </xl-upload2>
                </xl-form-item>
            </xl-form>
        </div>
        </xl-scrollbar>
        <div class="footer">
            <xl-button type="primary" @click="onSubmit">{{$t('design.orderDetail.confirmUpload') || '确定上传'}}</xl-button>
            <xl-button @click="onClose">{{$t('design.cancel') || '取消'}}</xl-button>
        </div>
    </div>
</div>
</template>

<script setup>
import { XlButton, XlUpload2, XlForm, XlFormItem, XlIcon, XlMessageBox, XlMessage, XlScrollbar } from '@shining3d/ui-components';
import { defineProps, ref, computed, inject, onMounted, watch } from 'vue';
import { CircleClose1 } from "@shining3d/icons-vue";
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang("@shining3d/xl-design-order");
import _get from 'lodash/get';
import router from '@/router';
import { VueCookieNext } from 'vue-cookie-next';
import orderDetailApis from '../../../api/orderDetail/index.js'; 
import CaseApi from '../../../api/case.js';
import { formatImageFile } from '../../../utils/common.js';
import { useStore } from 'vuex';

const $store = useStore();
const _id = _get( $store, 'state.factorySelect.id', '' );

const route = router.currentRoute.value;
const orderID = computed(() => _get( route, 'params.id', '' ));

const props = defineProps({ 
    platform: {
        type: String,
        default: 'dental'
    },
    modelValue: Boolean,
    info: {
        type: Object,
        default: () => ({})
    }
});
// 根据平台获取对应的API 默认平台为 dental
const Api = orderDetailApis[props.platform]

const emits = defineEmits(['update:modelValue', 'success']);
const getDetail = inject('getDetail');
const form = ref({
    fileList: []
});

const formConfig = ref({});
const activeType = ref('');
const onClickType = ( item ) => {
    activeType.value = item.detailType;
    formConfig.value = formatImageFile( item )
};

const getFileNameWithoutExt = (name) => {
  let n = name || ''
  if (n.includes('.')) {
    n = name.slice(0, name.lastIndexOf('.'))
  }
  return n
}

const getFileExt = (name) => {
  let ext = ''
  if (name.includes('.')) {
    ext = name.slice(name.lastIndexOf('.'), name.length)
  }
  return ext
}

function formatFileSize(fileSize) {
  if (!fileSize) {
    return
  }
  if (fileSize < 1024) {
    return fileSize + 'B'
  } else if (fileSize < 1024 * 1024) {
    let temp = fileSize / 1024
    temp = temp.toFixed(2) 
    return temp + 'KB'
  } else if (fileSize < 1024 * 1024 * 1024) {
    let temp = fileSize / (1024 * 1024)
    temp = temp.toFixed(2) 
    return temp + 'MB'
  } else {
    let temp = fileSize / (1024 * 1024 * 1024)
    temp = temp.toFixed(2) 
    return temp + 'GB'
  }
}

const upRemove = (file, rowFile) => {
    uploadRef.value.handleRemove(file, rowFile)
};

const onRemove = ( item ) => {
   
};
const uploadedsuccess = ( item ) => {
    
};

const beforeUpload = ( rowFile ) => {
    rowFile.detailType = activeType.value;
    rowFile.imageName = imageFileMap.value[activeType.value].imageName;
};

// const onCancel = () => {
//     emits( 'update:modelValue', false );
// };

const resetData = () => {
    form.value = {
        fileList: []
    };
};

const onClose = () => {
    if ( form.value.fileList.length ) {
        XlMessageBox({
            title: $t('design.confirmExit') || '确定退出',
            message: $t('design.orderDetail.exitAddTip') || '退出则不会保留当前数据',
            cancelButtonText: $t( 'design.cancel' ),
		    confirmButtonText: $t( 'design.confirm' )
        }).then(() => {
            resetData();
            emits( 'update:modelValue', false );
        });
    } else {
	    emits( 'update:modelValue', false );
    }
};

const onSubmit = () => {
    if ( !form.value.fileList.length ) {
        XlMessage({
            type: 'warning',
            message: $t('design.need.addfile') || '请上传补充文件'
        });
        return;
    }

    const imageFile = form.value.fileList.map(item => {
        return {
            ...item.response,
            detailType: item.raw.detailType
        }
    })
    const params = {
        orgID: _id,
        orderID: orderID.value,
        imageFile
    };
    
    const flag = form.value.fileList.some( item => item.status === 'uploading' ) ;
    if ( flag ) {
        XlMessage({
            type: 'warning',
            message: $t('design.file.uploading') || '文件正在上传中，请稍后'
        });
        return;
    }

    Api.supplyOrderFiles( params ).then(( res ) => {
        if ( res && res.status === 'success' ) {
            XlMessage({
                type: 'success',
                message: $t('design.replenish.file.success') || '文件补充成功'
            });
            emits( 'update:modelValue', false );
            emits( 'success' );
            getDetail();
        }
    });
};

const uploadErrorHandler = () => {
	XlMessage({ type: 'error', message: $t( 'design.dataAudit.uploadErr' ) });
};

const typeList = ref([]);
const imageFileMap = ref({});
const getFileConfig = () => {
    Api.fetchImageSetting({
        lang: VueCookieNext.getCookie('lang')
    }).then( res => {
        if ( res && res.status === 'success' ) {
            const list = res.result || [];
            const obj = {};
            list.forEach(item => {
                obj[item.imageUniqueCode] = item;
            });
            imageFileMap.value = obj;
        }
    });
};

watch(() => [props.info, imageFileMap.value], ( val ) => {
    const { required = {}, optional = {} } = val[0].uploadFileRestrict ? JSON.parse(val[0].uploadFileRestrict) : {};
    const keys = [...Object.keys(required), ...Object.keys(optional)];
    typeList.value = [];
    keys.forEach(item => {
        typeList.value.push({
            detailType: item,
            ...val[1][item]
        });
    });
}, { immediate: true, deep: true });

onMounted(() => {
    getFileConfig();
});

</script>

<style lang="scss" scoped>
.addfile-wrap {
    position: absolute;
    top: 0px;
    right: 0px;
    background: #fff;
    z-index: 99;
    width: 425px;
    height: 100%;
    transition: width 0.3s;
    box-shadow: 0px 10px 40px 0px #111B332E;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    .content {
        padding: 8px 4px 8px 24px;
        display: flex;
        flex-direction: column;
        height: 100%;
        box-sizing: border-box;
    }
    .head {
        padding-right: 20px;
        height: 68px;
        display: flex;
        overflow: hidden;
        justify-content: space-between;
        align-items: center;
        color: #2C364E;
        font-family: Alibaba PuHuiTi 2.0;
        font-size: 16px;
        font-weight: 700;
        border-bottom: 2px solid #EFF1F7;
        box-sizing: border-box;
        .close {
            background: url('../../../assets/image/closeBtn.svg');
            width: 24px;
            height: 24px;
            background-size: contain;
            cursor: pointer;
        }
    }
    .list {
        flex: 1;
        height: 100%;
        overflow-y: auto;
        box-sizing: border-box;
        padding: 16px 0px;
        overflow-x: hidden;
        padding-right: 20px;
        :deep(.el-form-item__label) {
            font-family: Alibaba PuHuiTi 2.0;
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            color: #737E99;
        }
        :deep(.el-form-item__content) {
            line-height: inherit;
        }
        :deep(.xl-upload) {
            width: 100%;
            .el-upload-list {
                margin-top: 0px;
                display: flex;
                flex-direction: column-reverse;
            }
        }
        :deep(.xl-upload-hide) {
            .el-upload__tip {
                display: none;
            }
        }
        :deep(.el-upload-list__item) {
            position: relative;
            margin-top: 38px;
            overflow: initial !important;
        }

        .file-detailName {
            position: absolute;
            top: -24px;
            left: 0px;
        }

        .types-wrap {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            padding-bottom: 10px;

            .type-item {
                padding: 0 20px;
                min-width: 80px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                box-sizing: border-box;
                border: 2px solid #E0E4EA;
                margin-right: 8px;
                font-size: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 6px;
                font-family: $font-family65;
                margin-bottom: 8px;
                cursor: pointer;
            }
            .type-item-active {
                border-color: #5587FF;
                color: #5587FF;
            }
        }
    }
    .footer {
        padding-right: 20px;
        height: 68px;
        border-top: 2px solid #EFF1F7;
        display: flex;
        overflow: hidden;
        flex-direction: row-reverse;
        align-items: center;
        box-sizing: border-box;
        :deep(.xl-button) {
            &:first-child {
                margin-left: 8px;
            }
        }
    }
}
.hide {
    width: 0px;
    box-shadow: none;
    .content, .head {
        width: 0px;
        overflow: hidden;
        display: none;
    }
}
</style>